import {createDefaultLogger} from '@hconnect/common/logging'

// Note: add 'azure' as a target to test the azure tracking locally
export const logger = createDefaultLogger('refraplanner')
